import { useEffect } from "react";
import Campuscare from "../Component/Campuscare";
import HomeSlider from "../Component/HomeSlider";
import ClassTabs from "../Component/ClassTabs";
import Events from "../Component/Events";
import Calendar from "../Component/Calender";
import Gallery from "../Component/Gallery";
import TopperXII from "../Component/TopperXII";
import TopperX from "../Component/TopperX";
import Birthday from "../Component/Birthday";
import { Link } from "react-router-dom";
import Message from "../Component/Message";
import OnlineRegistration from "../Component/OnlineRegistration";
import Popup from "../Component/Popup";
import Counter from "../Component/Counter";
import Pageloader from "../Component/Pageloader";
const Home = () => {
  useEffect(() => {
    document.title = " Home - The Frank Anthony Junior School,Bengaluru";
  });
  return (
    <>
      <Pageloader />
      <Popup></Popup>
      <Campuscare />
      <HomeSlider />
      {/* Counter */}
      <Counter />
      <OnlineRegistration>
      </OnlineRegistration>
      {/* about-section-two  */}
      <section className="about-section-two">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-5">
              <div className="about-img-wrap">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/aboutimg.jpg"
                  alt="About School"
                  className="img-fluid"
                />
              </div>
            </div>

            <div className="col-lg-7">
              <div className="about-card">

                <span className="about-tag">About Us</span>

                <h2>The Frank Anthony Junior School</h2>

                <p>
                  The Frank Anthony Junior School, Bengaluru, is a reputed educational
                  institutions in the city, established in 1971 by the late Mr. Frank Anthony.
                  The school has a rich legacy of excellence in education and holistic
                  development.
                </p>

                <p>
                  Mr. Frank Anthony was a distinguished national leader, legal luminary,
                  and educationist.
                </p>

                <Link to="/about-us" className="about-btn">
                  Read More
                  <i className="bi bi-arrow-right"></i>
                </Link>

              </div>
            </div>

          </div>
        </div>
      </section>
      {/* Facilities  */}
      <div className="classSection">
        <div className="row">
          <div className="col-lg-12">
            <div className="title">
              <h2 className="white">Facilities </h2>
            </div>
            <ClassTabs />
            {/* <button className="button readmorebtn">
              <Link to="/">
                View All <i class="bi bi-arrow-right"></i>
              </Link>
            </button> */}
          </div>
        </div>
      </div>
      {/* Academic calendar  */}
      <div className="event-calender">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 section-title">
              <div className="title">
                <h2>Academic calendar</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <Calendar />
            </div>
          </div>
        </div>
      </div>
      {/* Latest Events  */}
      <div className="event padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 section-title">
              <div className="title">
                <h2>Latest Events</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <Events />
              <button className="button readmorebtn mt-4">
                <Link to="/events">
                  View All <i class="bi bi-arrow-right"></i>
                </Link>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Message Section  */}
      <div className="messagebg padded-sec">
        <div className="container-fluid">
          <div className="row">

            <div className="col-lg-12">
              <Message />
            </div>
          </div>
        </div>
      </div>
      {/* toppersec Section  */}
      <div className="toppersec padded-sec">
        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-lg-6 col-md-6">
              <div className="trendingheading">
                <div className="title">
                  <p>our shining stars</p>
                  <h2>XII Toppers</h2>
                </div>
                <div className="btngif">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/btnimgbg.png" className="img-fluid" />
                  <Link to="/topper-XII">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/btnimg.gif" className="img-fluid" />
                  </Link>
                </div>
              </div>
              <div className="topperbg">
                <div className="topperbg1">
                  <TopperXII />
                </div>
              </div>
            </div> */}
            <div className="col-lg-12 col-12">
              <div className="trendingheading">
                <div className="title">
                  <p>our shining stars</p>
                  <h2>Class Toppers</h2>
                </div>
                <div className="btngif">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/btnimgbg.png" className="img-fluid" />
                  <Link to="/topper-X">
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/btnimg.gif" className="img-fluid" />
                  </Link>
                </div>
              </div>
              <div className="topperbg">
                <div className="topperbg1">
                  <TopperX />
                </div>
              </div>
            </div>
            {/* <div className="col-lg-4">
              <div className="trendingheading birthdayhead">
                <div className="title">
                  <p>stars of the day</p>
                  <h2>Birthday Section</h2>
                </div>
              </div>
              <div className="topperbg birthdaybg">
                <div className="topperbg1">
                  <Birthday />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* homegallery Section  */}
      <div className="homegallery padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 section-title">
              <div className="title">
                <h2>Photo Gallery</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <Gallery />
              <button className="button readmorebtn mt-4">
                <Link to="/gallery">
                  View All <i class="bi bi-arrow-right"></i>
                </Link>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
